/* eslint-disable */

const stickAnchor = (element, sticky) => {
   const sticky_link = sticky.querySelectorAll("a");
   const sticky_button = sticky.querySelector("button");
   const sticky_name = sticky.querySelector(".name");
   const sticky_inner = sticky.querySelector(".inner");

   const params = { threshold: [1], rootMargin: '-1px 0px 0px 0px' };
   const observer = new IntersectionObserver(([e]) => {
      sticky.style.height = e.boundingClientRect.y < 1 ? `${sticky_button.clientHeight}px` : 0;
   }, params);
   observer.observe(element);

   sticky_button.onclick = () => {
      sticky.classList.toggle("open");
      if (sticky.classList.contains("open")) {
         sticky.style.height = `${sticky_inner.clientHeight}px`;
      } else {
         sticky.style.height = `${sticky_button.clientHeight}px`;
      }
   };
   sticky_link.forEach(link => {
      link.onclick = e => {
         sticky.classList.remove("open");
         sticky.style.height = `${sticky_button.clientHeight}px`;
         sticky_link.forEach(link => link.classList.remove('active'))
         link.classList.add("active");
         sticky_name.innerText = link.innerText;
      }
   });


};


export default stickAnchor;